import { __awaiter } from "tslib";
import { v4 as uuidv4 } from 'uuid';
import { EXTERNAL_NAME as MANIFEST_CLIENT_NAME } from '@meltwater/mi-manifest-client/build/external-name';
class TrackingEvent {
    constructor(eventType, eventPayload, sourceComponent, subComponentAppID, sessionId) {
        this.sourceComponent = sourceComponent;
        this.subComponentAppID = subComponentAppID;
        this.sourcePage = window.location.href;
        this.originatedAt = new Date().toString();
        this.eventType = eventType;
        this.eventPayload = eventPayload;
        this.sessionId = sessionId;
    }
    populateUserContext() {
        return __awaiter(this, void 0, void 0, function* () {
            const manifestClient = window[MANIFEST_CLIENT_NAME];
            if (!manifestClient) {
                throw new Error(`Manifest client not found. Unable to populate tracking event user context`);
            }
            try {
                const manifestClientInstance = yield manifestClient['ManifestClient'].getInstance();
                const manifest = yield manifestClientInstance.getCurrentManifest();
                this.userContext = {
                    userId: manifest.user._id,
                    companyId: manifest.company._id,
                    language: manifest.user.language,
                    isInternal: manifest.user.isInternal
                };
            }
            catch (e) {
                throw new Error(`Failed fetching manifest client and populating tracking event user context`);
            }
        });
    }
}
class TrackingServiceController {
    constructor() {
        const currentHostName = window.location.hostname;
        if (currentHostName.indexOf('.com') !== -1) {
            this.iaTrackingUrl = 'https://v1.ia-tracking.meltwater.io/track';
            this.iaTrackingApiKey = 'gonL5rQusF6t2SSaxwpGC7BapzrXJbT7ymU5OTma';
            this.queueStorageKey = 'mi-ia-tracking';
            this.miIaTrackingSessionKey = 'mi-ia-tracking-session-id';
        }
        else {
            this.iaTrackingUrl = 'https://v1.staging.ia-tracking.meltwater.io/track';
            this.iaTrackingApiKey = 'u0VylkdcVCasUtls4EBM02Db6bsMJdpF7nj9UQ05';
            this.queueStorageKey = 'mi-ia-tracking-staging';
            this.miIaTrackingSessionKey = 'mi-ia-tracking-session-id-staging';
        }
        this.drainTrackingQueue();
    }
    sendTrackingEvent(eventType, eventPayload, sourceComponent, subComponentAppID, queuedTrackingEvent) {
        return __awaiter(this, void 0, void 0, function* () {
            let trackingEvent;
            if (!queuedTrackingEvent) {
                trackingEvent = new TrackingEvent(eventType, eventPayload, sourceComponent, subComponentAppID, this.getTrackingSessionIdByKey(sourceComponent));
                yield trackingEvent.populateUserContext();
            }
            else {
                trackingEvent = queuedTrackingEvent;
            }
            const trackingRequest = fetch(`${this.iaTrackingUrl}`, {
                method: 'POST',
                headers: {
                    'x-api-key': this.iaTrackingApiKey
                },
                body: JSON.stringify(trackingEvent)
            });
            return (yield trackingRequest).json();
        });
    }
    queueTrackingEvent(eventType, eventPayload, sourceComponent, subComponentAppID) {
        return __awaiter(this, void 0, void 0, function* () {
            const trackingEvent = new TrackingEvent(eventType, eventPayload, sourceComponent, subComponentAppID, this.getTrackingSessionIdByKey(sourceComponent));
            yield trackingEvent.populateUserContext();
            try {
                localStorage.setItem(this.queueStorageKey, JSON.stringify(trackingEvent));
            }
            catch (e) {
                console.debug(e);
            }
        });
    }
    drainTrackingQueue() {
        return __awaiter(this, void 0, void 0, function* () {
            const queuedTrackingEvent = localStorage.getItem(this.queueStorageKey);
            if (!queuedTrackingEvent) {
                return;
            }
            try {
                localStorage.removeItem(this.queueStorageKey);
                const parsedEvent = JSON.parse(queuedTrackingEvent);
                yield this.sendTrackingEvent(null, null, null, null, parsedEvent);
            }
            catch (e) {
                console.debug(e);
            }
        });
    }
    initTrackingSession(sessionKey) {
        const existingSessions = localStorage.getItem(this.miIaTrackingSessionKey);
        let updatedSessions = {};
        if (existingSessions === null || existingSessions === void 0 ? void 0 : existingSessions.length) {
            try {
                updatedSessions = JSON.parse(existingSessions);
            }
            catch (e) {
                console.debug('Unable to parse existing sessions. Creating a new one instead');
            }
        }
        updatedSessions[sessionKey] = uuidv4();
        localStorage.setItem(this.miIaTrackingSessionKey, JSON.stringify(updatedSessions));
    }
    getTrackingSessionIdByKey(sessionKey) {
        let sessionId;
        try {
            sessionId = JSON.parse(this.trackingSessionIds)[sessionKey];
        }
        catch (e) {
            console.debug(`No tracking session id found for key ${sessionKey}`);
        }
        return sessionId;
    }
    get trackingSessionIds() {
        return localStorage.getItem(this.miIaTrackingSessionKey);
    }
}
export const TrackingService = new TrackingServiceController();
//# sourceMappingURL=main.js.map